import { z } from 'zod';
import { IManager, managerSchema } from './IManager';
import { IFloor, floorSchema } from './IFloor';

// Schemas (source of truth for runtime validation)
export const activeManagerSchema = managerSchema.extend({
	disconnected: z.boolean().optional(),
	currentFloor: floorSchema.omit({ projectId: true }).optional(),
});

// Types (manual — Omit<IFloor> can't be expressed via z.infer cleanly)
export interface IActiveManager extends IManager {
	disconnected?: boolean;
	currentFloor?: Omit<IFloor, 'projectId'>;
}
